<template>
  <van-swipe class="my-swipe" :autoplay="5000" indicator-color="#1baeae">
    <van-swipe-item v-for="(item, index) in list" :key="index">
      <img :src="item.carouselUrl" alt="">
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: null
    }
  },
}
</script>

<style lang='less' scoped>

.my-swipe {
  .van-swipe-item {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 70%;
      height: 100%;
    }
  }
}
</style>
